import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/auditActions'
import * as api from '../api/audit'

function* getAuditRevisions(action) {
  try {
    const payload = yield call(api.getAuditRevisions, {
      target_id: action.targetId,
      table: action.table
    })
    yield put({ type: constants.GET_AUDIT_REVISIONS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_AUDIT_REVISIONS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAuditRevisions() {
  yield takeLatest(constants.GET_AUDIT_REVISIONS.ACTION, getAuditRevisions)
}

export function* rootSaga() {
  yield all([fork(watchGetAuditRevisions)])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/auditSaga.js